require("../output/Main/index.js").main();
